module.exports = __webpack_public_path__ + "img/icon_plus.110148fc.svg";